/**
 * Supported currencies for the application
 * ISO 4217 currency codes (lowercase)
 */
export const SUPPORTED_CURRENCIES = [
	{ code: 'usd', label: 'USD - US Dollar', symbol: '$' },
	{ code: 'cad', label: 'CAD - Canadian Dollar', symbol: '$' },
	{ code: 'gbp', label: 'GBP - British Pound', symbol: '£' },
	{ code: 'eur', label: 'EUR - Euro', symbol: '€' },
	{ code: 'aud', label: 'AUD - Australian Dollar', symbol: '$' },
	{ code: 'nzd', label: 'NZD - New Zealand Dollar', symbol: '$' },
]

/**
 * Get currency info by code
 * @param {string} code - ISO 4217 currency code (lowercase)
 * @returns {object|undefined} Currency object with code, label, and symbol
 */
export const getCurrencyByCode = (code) => {
	return SUPPORTED_CURRENCIES.find(c => c.code === code)
}

/**
 * Get currency symbol by code
 * @param {string} code - ISO 4217 currency code (lowercase)
 * @returns {string} Currency symbol (defaults to '$' if not found)
 */
export const getCurrencySymbol = (code) => {
	const currency = getCurrencyByCode(code)
	return currency?.symbol || '$'
}

/**
 * Format amount in cents to currency string
 * @param {number} amountInCents - Amount in cents
 * @param {string} currencyCode - ISO 4217 currency code (lowercase)
 * @returns {string} Formatted currency string (e.g., "$10.00")
 */
export const formatCurrencyAmount = (amountInCents, currencyCode = 'usd') => {
	const symbol = getCurrencySymbol(currencyCode)
	const amount = (amountInCents / 100).toFixed(2)
	return `${symbol}${amount}`
}

/**
 * Default currency code
 */
export const DEFAULT_CURRENCY = 'usd'
